module.exports = __webpack_public_path__ + "img/531a8da.svg";